import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="min-h-screen flex items-center justify-center bg-gray-50 px-4"
    >
      <div className="text-center space-y-6 max-w-md">
        <p className="text-sm font-medium tracking-widest text-gray-500 uppercase">
          404
        </p>
        <h1 className="text-3xl font-semibold text-gray-900">
          Page not found
        </h1>
        <p className="text-sm text-gray-600">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/">
          <Button data-testid="not-found-back-to-dashboard" variant="default">
            Back to Dashboard
          </Button>
        </Link>
      </div>
    </div>
  );
}
